import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueRollingInequalityWithUnit = ({
  operator
}) => {
  const key = `customerDataFiltersUI.customerDataFilters.DisplayValueRollingInequalityWithUnit.${operator.direction}.${operator.timeUnit}`;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: key,
    options: {
      count: operator.value
    }
  });
};
export default DisplayValueRollingInequalityWithUnit;